import React, { useEffect, useState, useMemo, useCallback } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";
function Recycle() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [customer, setCustomer] = useState([]);
    const [error, setError] = useState(null);
        const [searchQuery, setSearchQuery] = useState("");
            const [currentPage, setCurrentPage] = useState(1);
                const [stbCount, setStbCount] = useState(true);
    const rowsPerPage = 30;
    const user = getCookie('user');

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
      const downloadCSV = () => {
  const headers = [
    "Sno", "Customer_Name", "Acc_no", "Code", "STB_no", "Door_no", "Flat_name",
    "Street_name", "Phone", "Pay_Status", "Plan_Amount", "Paid_Amount", "Paid_Date",
    "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
    "Staff_Code", "Network", "Paid_time", "Package", "Added_date", "Collection_Staff"
  ];

  const csvRows = [];
  csvRows.push(headers.join(",")); // header row


     customer.forEach((row, index) => {
    const values = [
      index + 1, 
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street,
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy
    ];

    // Properly escape and wrap every value
    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""'); // escape quotes
      return `"${str}"`; // wrap with double quotes
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "recycleCustomer.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

   // 1. FILTER FIRST
const filteredRows = customer.filter((row) =>
  Object.values(row).some(value =>
    String(value).toLowerCase().includes(searchQuery.toLowerCase())
  )
);


// 3. PAGINATE FILTERED DATA ONLY
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

// 4. TOTAL PAGES FOR FILTERED DATA
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

// 5. Pagination function
const paginate = (pageNumber) => setCurrentPage(pageNumber);
    useEffect(() => { if (!user) { navigate('/login') } }, [user, navigate]);

    async function handleDelete(id) {
        try {
            const response = await axios.post('https://node.cabletvpay.in/handleDelete', { user, id });
            if (response.status === 200) {
                toast.success("Customer Deleted permanently");
                handleGetRecycle();
            }
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            toast.error(error.response?.data?.message || "Error fetching data");
        }
    }

  async function handleRecover(id) {
    try {
        const response = await axios.post('https://node.cabletvpay.in/handleRecover', { user, id });
        if (response.status === 200) {
            toast.success("Customer Recover Successfully");

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    } catch (error) {
        console.log(error.response?.data?.message || "Error fetching data");
        toast.error(error.response?.data?.message || "Error fetching data");
    }
}

    async function handleGetRecycle() {
        try {
            const response = await axios.post('https://node.cabletvpay.in/getRecycle', { user });
            if (response.status === 200) { setCustomer(response.data.customer);   setStbCount(response.data.customer.length);console.log(response.data.customer); setLoading(false); }
        } catch (error) { console.log(error.response?.data?.message || "Error fetching data"); toast.error(error.response?.data?.message || "Error fetching data"); }
    }
    const stb = useMemo(() => customer.map(row => parseInt(row.serial_num, 10)), [customer]);
        const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { handleGetRecycle() }, [user])

    if (loading) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}><RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" /></div></div>);
    }

    if (error) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}><img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} /></div></div>);
    }

    return (
       <div className="content-wrapper">
                  <div className="content-header pt-1">
                      <h5 className='h5'>PAID CUSTOMER DETAILS</h5><hr className='mt-0' />
                      <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                     
                      <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                          <div className="card-header filterBtn">
                              <div className="row">
                                  <div className="col-lg-4">
                                      <div className="text-left mb-lg-0 w-50">
                                          <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                      </div>
                                  </div>
                                  <div className="col-lg-8 mt-1">
                                      <span><div className="row w-auto">
                                          <div className="col-11 col-lg-6">
                                              <div className="input-group">
                                                  <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                                  <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                              </div>
                                          </div>
                                          <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                              <div className="d-flex justify-content-end">
                                                  <div className=" btn-group">
                                                      <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                      <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div></span>
                                  </div>
                              </div>
                          </div>
                        <div className="card-body p-0 bg-light">
                    <table id="myTable" className="table table-bordered  table-lg-responsive">
                         <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sno</th>
                                    <th>Name</th>
                                    <th>Account</th>
                                    <th>Code</th>
                                    <th>STB</th>
                                    <th>Network</th>
                                    <th>Door</th>
                                    <th>Street</th>
                                    <th>Flat Name</th>
                                    <th>Mobile</th>
                                    <th>Payment</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Balance</th>
                                    <th>Package</th>
                                    <th>Connection</th>
                                    <th>Recover</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                                 <tbody className='text-dark'>
                                {
                                    currentRows.length > 0 ? (
                                        currentRows.map((row, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{row.name}</td>
                                                <td>{row.account_num}</td>
                                                <td>{row.acc_num}</td>
                                                <td>{row.serial_num}</td>
                                                <td>{row.net_name}</td>
                                                <td>{row.doorno}</td>
                                                <td>{row.street}</td>
                                                <td>{row.flat_name}</td>
                                                <td>{row.mobile}</td>
                                                <td>{row.status}</td>
                                                <td>{row.pay_amt}</td>
                                                <td>{row.paid_amt}</td>
                                                <td>{row.balance_amt}</td>
                                                <td>{row.package}</td>
                                                <td>{row.con_status}</td>
                                                <td><button className='btn btn-outline-primary' onClick={() => { handleRecover(row.id) }} ><i className="fas fa-sync" /></button></td>
                                                <td><button className='btn btn-outline-danger' onClick={() => { handleDelete(row.id) }} ><i className="fas fa-trash-alt" /></button></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className='bg-white'>
                                            <td colSpan="18">No results found</td>
                                        </tr>
                                    )
                                }
                            </tbody>
      
                              </table>
                          </div>
                          <div className="card-footer">
                              <div className="d-flex justify-content-end">
                                  <div className="pagination btn-group border-dark text-bold">
                                      <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                      <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-dark text-bold active" : "btn-dark"} border-left`} > 1 </button>
                                      {currentPage > 3 && <span className="mx-1">...</span>}
                                      {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                          .filter((page) => page > 1 && page < totalPages)
                                          .map((page) => (
                                              <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-dark text-bold active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                          ))}
                                      {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                      {totalPages > 1 && (
                                          <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-dark text-bold active" : "btn-dark"} border-right`} > {totalPages} </button>
                                      )}
                                      <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                                  </div>
                              </div>
                          </div>
                      </div>
      
                  </div>
              </div>
    )
}
export default Recycle;